let cartItemsComponent = null;
function smDebounce(fn, wait) {
    let t;
    return function (...args) {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
async function smFetchCart() {
    try {
        const res = await fetch("/cart.js");
        const cart = await res.json();
        const wrappers = document.querySelectorAll(".sm-cart__quantity");
        wrappers.forEach((wrapper) => {
            const variantId = parseInt(wrapper.dataset.variantId);
            const input = wrapper.querySelector(".sm-cart__quantity-field");
            const item = cart.items.find((i) => i.variant_id === variantId);
            if (input) input.value = item ? item.quantity : 0;
        });
    } catch (err) {
        console.error("Fetching cart failed:", err);
    }
}
const smDebounceFetchCart = smDebounce(smFetchCart, 300);
async function smUpdateCart({ variantId, newQty, wrapper }) {
    const input = wrapper.querySelector(".sm-cart__quantity-field");
    const spinner = wrapper.querySelector(".sm-cart__spinner");
    if (spinner) spinner.style.display = "flex";
    if (input) input.style.visibility = "hidden";
    try {
        const res = await fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ updates: { [variantId]: newQty } }) });
    } catch (err) {
        console.error(`Cart update failed for variant ${variantId}:`, err);
    } finally {
        if (spinner) spinner.style.display = "none";
        if (input) input.style.visibility = "visible";
        if (typeof cartItemsComponent?.getCart === "function") {
            cartItemsComponent.getCart();
        } else {
            console.log("Error Cart", cartItemsComponent);
        }
        smFetchCart();
    }
}
const smDebounceUpdateCart = smDebounce((variantId, newQty, wrapper) => {
    smUpdateCart({ variantId, newQty, wrapper });
}, 300);
function smAdd(buttonElement) {
    const wrapper = buttonElement.closest(".sm-cart__quantity");
    const input = wrapper.querySelector(".sm-cart__quantity-field");
    const max = parseInt(wrapper.dataset.max, 10);
    const variantId = parseInt(wrapper.dataset.variantId, 10);
    let currentQty = parseInt(input.value, 10);
    if (currentQty < max) {
        currentQty++;
        input.value = currentQty;
        smDebounceUpdateCart(variantId, currentQty, wrapper);
    }
}
function smMinus(buttonElement) {
    const wrapper = buttonElement.closest(".sm-cart__quantity");
    const input = wrapper.querySelector(".sm-cart__quantity-field");
    const variantId = parseInt(wrapper.dataset.variantId, 10);
    let currentQty = parseInt(input.value, 10);
    if (currentQty > 0) {
        currentQty--;
        input.value = currentQty;
        smDebounceUpdateCart(variantId, currentQty, wrapper);
    }
}
function smInput(inputElement) {
    const wrapper = inputElement.closest(".sm-cart__quantity");
    const variantId = parseInt(wrapper.dataset.variantId, 10);
    const max = parseInt(wrapper.dataset.max, 10);
    let newQty = parseInt(inputElement.value, 10);
    if (isNaN(newQty)) newQty = 0;
    if (newQty > max) {
        newQty = max;
        inputElement.value = max;
    }
    if (newQty < 0) {
        newQty = 0;
        inputElement.value = 0;
    }
    smDebounceUpdateCart(variantId, newQty, wrapper);
}
function smInputFix() {
    let inputs = document.querySelectorAll(".sm-cart__quantity-field");
    inputs.forEach(function(input) {
        if (!input.hasAttribute('data-listener-bound')) {
            input.addEventListener('click', function() {
                input.value = '';
                input.focus();
                const length = input.value.length;
                input.setSelectionRange(length, length);
            });
            input.setAttribute('data-listener-bound', 'true');
        }
    });
}

function smWaitQuantityField() {
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType === 1 && (node.matches(".sm-product-item__card") || node.querySelector(".sm-product-item__card"))) {
                    smDebounceFetchCart();
                    smInputFix();
                }
            }
        }
    });
    observer.observe(document.body, { childList: !0, subtree: !0 });
}
function smWaitCartItems() {
    const observer = new MutationObserver((mutations, obs) => {
        if (document.querySelector("cart-items")) {
            cartItemsComponent = document.querySelector("cart-items");
            obs.disconnect();
        }
    });
    observer.observe(document.body, { childList: !0, subtree: !0 });
}
document.addEventListener("DOMContentLoaded", () => {
    smInputFix();
    smWaitCartItems();
    smWaitQuantityField();
});
